import { useDispatch } from "react-redux";
import useCustomers from "../../hooks/useCustomers";
import { URLdecode } from "../../utils/url";
import { customerConfig } from "../../customerConfig";
import { useEffect, useState } from "react";

function CustomerFilteringSection({ search, setSearch, setTab }) {
  const params = URLdecode();
  const { filterTabs } = useCustomers();

  const getPlaceholder = () => {
    let placeholder = "Search by name, email, or phone number";

    return placeholder;
  };

  const handleSearchValueChange = (e) => {
    setSearch(e.target.value);
  };

  return (
    <div className="w-full flex flex-col mt-3">
      <div className="flex flex-col md:flex-row items-center gap-2 md:gap-10 justify-between w-full md:overflow-x-scroll scroll-hide">
        <OrderFilterTypeDropdown setTab={setTab} />
        <div className="flex flex-1 w-full flex-shrink-0 h-12 py-3 md:py-0 rounded-lg items-center border-2 border-[#DBDBDB] px-4 gap-3">
          <input
            type="text"
            className="flex flex-1 text-sm font-main"
            value={search}
            onChange={handleSearchValueChange}
            placeholder={getPlaceholder()}
          />
          <img src="/IconSearch1.svg" alt="" />
        </div>
        <div className="hidden md:flex items-center gap-2">
          {filterTabs().map((tab, tabIndex) => {
            const isSelected = !params?.tab
              ? tab.value === customerConfig.filterTabs.all.code
              : tab.value === params?.tab;
            return (
              <button
                key={tabIndex}
                onClick={() => {
                  tab?.onClick();
                  setTab?.(tab.value);
                }}
                className={`h-10 flex items-center justify-between gap-2 px-3 font-bold rounded-md ${
                  isSelected
                    ? "text-white bg-[#4E5662]"
                    : "text-[#6D7C94] bg-[#F8F8F8]"
                }`}
              >
                <span className="text-xs md:text-sm">{tab?.label}</span>
                {/* <span
                  className={`text-xs px-2 rounded-md py-1 ${
                    isSelected ? "text-[#47A0FA] bg-[#5F6978]" : "bg-[#F1F1F1]"
                  }`}
                >
                  {tab?.amount}
                </span> */}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default CustomerFilteringSection;

const OrderFilterTypeDropdown = ({ setTab }) => {
  const params = URLdecode();
  const { filterTabs } = useCustomers();
  const [dropdown, setDropdown] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdown) {
        setTimeout(() => {
          setDropdown(false);
        }, 100);
      }
    };

    window.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdown, setDropdown]);

  return (
    <div
      className="w-full flex  md:hidden relative"
      onClick={() => setDropdown(!dropdown)}
    >
      <div className="h-10 w-full flex flex-row rounded-md bg-primary1 items-center justify-between px-3 cursor-pointer">
        <span className="text-sm font-bold text-white">
          {!params?.tab
            ? filterTabs()?.at(0)?.label
            : filterTabs()?.find((tab) => tab?.value === params?.tab)?.label ||
              filterTabs()?.at(0)?.label}
        </span>
        <img src="/IconChevronWhiteDown.svg" alt="" />
      </div>
      {dropdown && (
        <div className="absolute w-full z-20 top-10 bg-[#F8F8F8] rounded-md shadow-md py-2 gap-2">
          {filterTabs().map((tab, tabIndex) => {
            const isSelected = !params?.tab
              ? tab.value === customerConfig.filterTabs.all.code
              : tab.value === params?.tab;
            return (
              <div
                key={tabIndex}
                onClick={() => {
                  tab?.onClick();
                  setTab?.(tab.value);
                }}
                className={`text-sm font-bold px-2 py-2 ${
                  isSelected
                    ? "text-white bg-primary1"
                    : "text-[#818083] bg-[#F8F8F8]"
                }`}
              >
                {tab.label}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};
